import { ServiceSalaryComponent } from './ui';

export { ServiceSalaryComponent };
